module.exports = __webpack_public_path__ + "img/00e6b4e.png";